import styled from 'common/styled-components';

export const Container = styled.div`
    height: 100%;
    border-radius: 4px;
    background-color: ${props => props.theme.white.light};
    display: flex;
    flex-direction: column;
`;

export const ShortcutsContainer = styled.div`
    height: calc(100% - 68px);
    padding-left: 3vw;
`;

export const RowContainer = styled.div<{header?: boolean}>`
    display: flex;
    ${props => props.header ? 'background-color: ;' : ''}
`;

export const ShortcutsList = styled.div`
    overflow: auto;
    height: calc(100% - 28px);
`;

export const KbdShortcut = styled.div`
    overflow: hidden;
    width: 180px;
    padding: 10px 0px;
`;

export const Key = styled.kbd`
    display: inline-block;
    text-align: center;
    background-color: ${props => props.theme.white.main};
    padding: 4px 8px;
    border: 1px solid ${props => props.theme.white.dark};
    border-radius: 6px;
    box-shadow:
        0 1px 1px ${props => props.theme.grey.light},
        0 2px 0 0 ${props => props.theme.white.main} inset;
;`

export const ShortcutAction = styled.span`
    width: 70%;
    max-width: 400px;
    padding-right: 15px;
    align-content: center;
`;